class IluProductVideoModal {
  constructor() {
    document.addEventListener('click', this.handleClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  activeOverlay = null;
  lastTrigger = null;

  handleClick = (event) => {
    const openButton = event.target.closest('[data-ilu-product-video-open]');
    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      this.open(openButton.getAttribute('data-ilu-product-video-open'), openButton);
      return;
    }

    const closeButton = event.target.closest('[data-ilu-product-video-close]');
    if (closeButton) {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.target.matches('[data-ilu-product-video-overlay]')) {
      this.close();
    }
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape' && this.activeOverlay) {
      this.close();
    }
  };

  open(templateId, trigger) {
    const template = document.getElementById(templateId);
    if (!template) return;

    this.close(false);
    this.lastTrigger = trigger;

    const overlay = document.createElement('div');
    overlay.className = 'ilu-product-video-overlay';
    overlay.setAttribute('data-ilu-product-video-overlay', '');
    overlay.innerHTML = template.innerHTML;
    document.body.appendChild(overlay);

    this.activeOverlay = overlay;
    document.documentElement.classList.add('ilu-video-modal-open');

    requestAnimationFrame(() => {
      overlay.classList.add('is-visible');
      overlay.querySelector('[data-ilu-product-video-close]')?.focus({ preventScroll: true });
      this.play(overlay);
    });
  }

  close(restoreFocus = true) {
    if (!this.activeOverlay) return;

    const overlay = this.activeOverlay;
    this.pause(overlay);
    overlay.remove();
    this.activeOverlay = null;
    document.documentElement.classList.remove('ilu-video-modal-open');

    if (restoreFocus) {
      this.lastTrigger?.focus?.({ preventScroll: true });
    }
  }

  play(overlay) {
    const video = overlay.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.controls = true;
      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => {});
    }
  }

  pause(overlay) {
    const video = overlay.querySelector('video');
    if (video) video.pause();

    const iframe = overlay.querySelector('iframe[data-video-type]');
    if (!iframe?.contentWindow) return;
    if (iframe.dataset.videoType === 'youtube') {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
    if (iframe.dataset.videoType === 'vimeo') {
      iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    }
  }
}

if (!window.iluProductVideoModal) {
  window.iluProductVideoModal = new IluProductVideoModal();
}
